import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { experience } from "../../data/profile";
import { motion } from "framer-motion";
import { MdWork } from "react-icons/md";
import { BsBuilding } from "react-icons/bs";
import { FiChevronRight } from "react-icons/fi";

export default function Experience() {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.08, delayChildren: 0.05 },
    },
  };

  const item = {
    hidden: { opacity: 0, x: -14, y: 6 },
    show: { opacity: 1, x: 0, y: 0, transition: { duration: 0.45 } },
  };

  return (
    <Container className="experience-section">
      <motion.h1
        className="project-heading"
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        Work <strong className="purple">Experience</strong>
      </motion.h1>

      <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
        <Col md={10} lg={9}>
          <motion.div
            className="exp-timeline-wrapper"
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.25 }}
          >
            <div className="exp-spine" aria-hidden="true" />

            {experience.map((entry, idx) => {
              const isActive = idx === 0 && /present/i.test(entry.period);
              return (
                <motion.div
                  key={`${entry.company}-${entry.title}`}
                  className="exp-entry"
                  variants={item}
                >
                  <div className="exp-dot" aria-hidden="true" />

                  <div className="exp-card">
                    <div className="exp-card-header">
                      <div className="exp-role">
                        <span className="exp-role-icon" aria-hidden="true">
                          <MdWork />
                        </span>
                        <span>{entry.title}</span>
                      </div>
                      <div className="exp-period-badge">{entry.period}</div>
                    </div>

                    <div className="exp-company-row">
                      <span className="exp-company">
                        <BsBuilding style={{ marginRight: "8px" }} />
                        {entry.company}
                      </span>
                      {isActive && <span className="exp-active-badge">Active</span>}
                    </div>

                    <ul className="exp-highlights">
                      {entry.highlights.map((h) => (
                        <li key={h}>
                          <FiChevronRight className="exp-highlight-icon" />
                          <span>{h}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.div>
              );
            })}
          </motion.div>
        </Col>
      </Row>
    </Container>
  );
}

